module.exports = __webpack_public_path__ + "static/media/PremierMedia.27ab4c90.png";